// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1VPnu","sendOtp":"AuthorizeToLogin_sendOtp__2PQGt"};